import script from "./DetailDeliveryTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailDeliveryTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DetailDeliveryTemplate.vue?vue&type=style&index=0&id=5e61f2a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e61f2a4"]])

export default __exports__